import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./artistArenaModal.module.css";

const ArenaIntroModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if the user has seen the modal before
    const hasSeenModal = localStorage.getItem("hasSeenArenaModal");

    if (!hasSeenModal) {
      // If not, show the modal and set the flag
      setIsOpen(true);
      localStorage.setItem("hasSeenArenaModal", "true");
    }
  }, []);

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleNavigateToArena = () => {
    setIsOpen(false);
    navigate("/artist-next-door-arena");
  };

  if (!isOpen) return null;

  return (
    <div className={classes.modalOverlay}>
      <div className={classes.modalContent}>
        {/* Modal Header with Red Gradient */}
        <div className={classes.modalHeader}>
          <h2 className={classes.modalTitle}>
            <span className={classes.modalIcon}>🏆</span>
            ArtistNextDoor Arena Awaits You!
          </h2>
          <button onClick={handleClose} className={classes.closeButton}>
            ×
          </button>
        </div>

        {/* Modal Body */}
        <div className={classes.modalBody}>
          <div className={classes.bannerBox}>
            <p className={classes.bannerTitle}>AB INDIA KAREGA COMPETE!</p>
            <p className={classes.bannerSubtitle}>
              Where talent meets opportunity, and votes decide the stars.
            </p>
          </div>

          <h3 className={classes.sectionTitle}>Showcase Your Talent</h3>
          <p>
            The ArtistNextDoor Arena is your platform to shine! Singers,
            musicians, magicians, photographers, video editors - all artists can
            now compete with their digital performances.
          </p>

          <div className={classes.categoriesContainer}>
            <div className={classes.categoryCard}>
              <span className={classes.categoryIcon}>🎵</span>
              <p className={classes.categoryText}>Musicians</p>
            </div>
            <div className={classes.categoryCard}>
              <span className={classes.categoryIcon}>🎭</span>
              <p className={classes.categoryText}>Performers</p>
            </div>
            <div className={classes.categoryCard}>
              <span className={classes.categoryIcon}>📸</span>
              <p className={classes.categoryText}>Visual Artists</p>
            </div>
            <div className={classes.categoryCard}>
              <span className={classes.categoryIcon}>🎬</span>
              <p className={classes.categoryText}>Editors</p>
            </div>
          </div>

          <h3 className={classes.sectionTitle}>How It Works</h3>
          <ul className={classes.featureList}>
            <li>Compete in weekly contests</li>
            <li>Gather votes from fans and viewers</li>
            <li>Winners receive exciting prizes</li>
            <li>Build your audience and reputation</li>
          </ul>

          <div className={classes.prizeBox}>
            <p className={classes.prizeText}>
              The highest-voted performer each week wins amazing prizes!
            </p>
          </div>
        </div>

        {/* Modal Footer */}
        <div className={classes.modalFooter}>
          <button onClick={handleClose} className={classes.secondaryButton}>
            Maybe Later
          </button>
          <button
            onClick={handleNavigateToArena}
            className={classes.primaryButton}
          >
            Start Competing Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default ArenaIntroModal;
